module.exports = __webpack_public_path__ + "static/new_patient_form-4f66f3ccb925e59066df7050a9d0ecb1.pdf";